import { useEffect } from "react";
import { useQuery } from "react-query";
import styled from "styled-components";
import { getOnePolicyItem } from "../api/api";
import { IInnerPolicy } from "../types/inner_page";
import { TailSpin } from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import InnerPageLayout from "../Components/Layout/InnerPageLayout";
import { useParams } from "react-router-dom";
import { Accordion, Card, Tab, Tabs } from "react-bootstrap";
import PdfEmbed from "./PdfEmbed";

interface IProps {
  id?: string;
}
const PolicyPage = (props: IProps) => {
  // const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });
  let { id } = useParams();

  const { i18n } = useTranslation();

  const { isLoading, error, data, refetch }: any = useQuery(
    `innerPolicyData-${id}`,
    () => getOnePolicyItem({ id: id || "1", language: i18n.language })
  );

  useEffect(() => {
    refetch();
  }, [i18n.language, refetch]);

  if (isLoading)
    return (
      <InnerPageLayout>
        <LoaderContainer>
          <TailSpin color="#ffffff" height={70} width={70} />
        </LoaderContainer>
      </InnerPageLayout>
    );

  if (error)
    return (
      <InnerPageLayout>
        <div></div>
      </InnerPageLayout>
    );

  return (
    <InnerPageLayout>
      <>
      
        <Tabs defaultActiveKey="0" id="faq-tabs" className="mb-3 tabs">
        {data["data"].map((pageItem: any, index: number) => (

            <Tab
              eventKey={index} 
              title={pageItem.attributes.Title}
              key={index} 
            >
              <PdfEmbed embedURL={`${process.env.REACT_APP_CMS}${pageItem.attributes.file.data.attributes.url ?? ''}`} />

            </Tab>
                      ))}


       


        </Tabs>


       
      </>
    </InnerPageLayout>
  );
};

const LoaderContainer = styled.div`
  min-height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export default PolicyPage;
